import { CartLineInput } from '../types';
import { CartPolicy } from './types';
import {
  cartWithoutPendingRemovals,
  findExistingCartLine,
  getMaxQuantityReachedMessage,
  parseLineMaxQuantity,
  pass,
} from './cartLineHelpers';

export const maxQuantityPolicy: CartPolicy = (input, cart, meta) => {
  const lines = input.lineItemsToAdd;
  if (!lines?.length) return pass(input);

  const view = cartWithoutPendingRemovals(cart, input);
  const kept: CartLineInput[] = [];
  let userMessage: string | undefined;

  for (const line of lines) {
    const existing = findExistingCartLine(line, view, meta.store);
    const effectiveMax =
      parseLineMaxQuantity(line.attributes) ??
      parseLineMaxQuantity(existing?.attributes);
    if (existing && effectiveMax && existing.quantity >= effectiveMax) {
      userMessage = getMaxQuantityReachedMessage(effectiveMax);
      continue;
    }
    kept.push(line);
  }

  if (kept.length === lines.length) return pass(input);

  return {
    input: { ...input, lineItemsToAdd: kept },
    blocked: kept.length === 0,
    userMessage,
    reasons: ['max quantity reached for one or more lines'],
  };
};
